
interface Props {
  fill?: string;
  size?: number;
  className?: string;
  checkmarkFill?: string;
}

export default function CheckmarkInCircle({
  fill = 'var(--success-green)',
  checkmarkFill,
  size = 20,
  className,
}: Props) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 0C11.1111 0 0 11.1111 0 25C0 38.8889 11.1111 50 25 50C38.8889 50 50 38.8889 50 25C50 11.1111 38.8889 0 25 0ZM34.7222 18.0556L25 33.6111C24.7222 34.4444 23.8889 34.7222 23.3333 34.7222C22.7778 34.7222 21.9444 34.4444 21.6667 33.8889L16.6667 27.5C16.3889 27.2222 16.1111 26.6667 16.1111 26.1111C16.1111 25 16.9444 24.1667 18.0556 24.1667C18.6111 24.1667 19.4444 24.4444 19.7222 25L23.3333 29.4444L31.3889 16.1111C31.3889 15.8333 31.6667 15.8333 31.6667 15.8333C31.9444 15.2778 32.5 15 33.0556 15C34.1667 15 35 15.8333 35 16.9444C35 17.5 35 17.7778 34.7222 18.0556Z"
        fill={fill}
      />
      <path
        d="M25 33.6111L34.7222 18.0556C35 17.7778 35 17.5 35 16.9444C35 15.8333 34.1667 15 33.0556 15C32.5 15 31.9444 15.2778 31.6667 15.8333C31.6667 15.8333 31.3889 15.8333 31.3889 16.1111L23.3333 29.4444L19.7222 25C19.4444 24.4444 18.6111 24.1667 18.0556 24.1667C16.9444 24.1667 16.1111 25 16.1111 26.1111C16.1111 26.6667 16.3889 27.2222 16.6667 27.5L21.6667 33.8889C21.9444 34.4444 22.7778 34.7222 23.3333 34.7222C23.8889 34.7222 24.7222 34.4444 25 33.6111Z"
        fill={checkmarkFill || (fill === 'white' ? 'transparent' : 'white')}
      />
    </svg>
  );
}
